module.exports = __webpack_public_path__ + "img/Dash_print.ae33f721.svg";